module.exports = __webpack_public_path__ + "img/mastercard.63b36587.svg";